function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M40.1,69.9H18.5c-3.8,0-7.1-2.7-7.7-6.5L4.7,29.6c-1.1-6.4,3.1-12.6,9.5-13.7,.7-.1,1.4-.2,2.1-.2h25.9c6.5,0,11.8,5.3,11.8,11.8,0,.7,0,1.4-.2,2.1l-6.1,33.7c-.7,3.8-3.9,6.5-7.8,6.5Z",
  fill: "none",
  stroke: "current",
  strokeMiterlimit: 10,
  strokeWidth: 3
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M1.5,56.9v13.8c0,4.4,3.5,8.1,7.9,8.3H49.2c4.3,0,7.9-3.9,7.9-8.3v-13.8",
  fill: "none",
  stroke: "current",
  strokeMiterlimit: 10,
  strokeWidth: 3
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M14.1,114v-7.5c0-2.2,1.8-3.9,3.9-3.9h25.5c2.2,0,3.9,1.8,3.9,3.9h0v7.5",
  fill: "none",
  stroke: "current",
  strokeMiterlimit: 10,
  strokeWidth: 3
});
var _ref5 = /*#__PURE__*/React.createElement("line", {
  x1: 30.7,
  y1: 114,
  x2: 30.7,
  y2: 77.5,
  fill: "none",
  stroke: "current",
  strokeMiterlimit: 10,
  strokeWidth: 3
});
var _ref6 = /*#__PURE__*/React.createElement("g", {
  id: "Ebene_2"
}, /*#__PURE__*/React.createElement("path", {
  d: "M50.9,33.6c9.2,0,16.8-7.6,16.8-16.8S60.1,0,50.9,0s-16.8,7.6-16.8,16.8h0c0,9.2,7.4,16.8,16.8,16.8h0Z",
  fill: "current"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
  x1: 50.9,
  y1: 6.8,
  x2: 50.9,
  y2: 26.8,
  fill: "none",
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("line", {
  x1: 60.8,
  y1: 16.8,
  x2: 40.9,
  y2: 16.8,
  fill: "none",
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: 3
})));
function SvgAddcompanyDeactivated(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_11_copy",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 67.7 114",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddcompanyDeactivated);
export default __webpack_public_path__ + "static/media/Add company-deactivated.cb0f2f46.svg";
export { ForwardRef as ReactComponent };